import { store } from './slices/index';
import * as Forms from './slices/formsSlice';
import * as Quotes from './slices/quotesSlice';
import * as User from './slices/userSlice';
import * as UI from './slices/uiSlice';
import { AnyAction } from '@reduxjs/toolkit';
import React from 'react';

export interface validRetType {
	valid: boolean,
	message: string
}

export const handleScroll = () => {
	const dispatch = store.dispatch;

	dispatch((UI.closeMenu()) as unknown as AnyAction);
};

export const instructCase = (el: string, id: string) => {
	const dispatch = store.dispatch;
	const quotes = store.getState().quotes;

	if (!quotes.quote.isInstructing) {
		if (validateForm(el, id)) {
			dispatch(Quotes.setInstructing(true));
			const user = store.getState().user;
			const json = getJSONWithFormValues(id);
			const state: Quotes.acceptQuoteState = {
				id: quotes.quote.quoteid,
				generated: quotes.quote.generated,
				accepted: quotes.quote.accepted,
				instructed: quotes.quote.instructed,
				schemeid: getFormValueWithId(id, 'quote_scheme_id'),
				introducerid: getFormValueWithId(id, 'quote_introducer_id'),
				developerid: getFormValueWithId(id, 'quote_developer_id'),
				siteid: getFormValueWithId(id, 'quote_site_id'),
				mattertype: quotes.quote.type,
				createdby: user.id,
				filename: '',
				quoteformdata: quotes.quote.quoteformdata,
				quotebreakdowndata: quotes.quote.quotebreakdowndata,
				instructionformdata: json
			}
			dispatch(Quotes.setInstructionFormData(json) as unknown as AnyAction);
			if (quotes.quote.type === 'Purchase') {
				dispatch(Quotes.instructPurchase(state) as unknown as AnyAction).then((result: any) => {
					let action;
					try {
						action = JSON.parse(result.payload as string);
					} catch (e) {
						dispatch(UI.setError({ visible: true, message: e as string }));
						return;
					}
					if (action.Status === 'OK') {
						dispatch(UI.setInfo({ visible: true, message: 'Thank you for your instruction. The file will be opened within the next 4 working hours. We will send to the client their PLS 247 app log in details shortly. Within our app, they can complete their initial paperwork, track the progress of their file and message the team.' }));
						return;
					} else {
						dispatch(UI.setError({ visible: true, message: 'Instruction Failed' }));
						return;
					}
				});
			}
			if (quotes.quote.type === 'Remortgage') {
				dispatch(Quotes.instructRemortgage(state) as unknown as AnyAction).then((result: any) => {
					let action;
					try {
						action = JSON.parse(result.payload as string);
					} catch (e) {
						dispatch(UI.setError({ visible: true, message: e as string }));
						return;
					}
					if (action.Status === 'OK') {
						dispatch(UI.setInfo({ visible: true, message: 'Thank you for your instruction. The file will be opened within the next 4 working hours. We will send to the client their PLS 247 app log in details shortly. Within our app, they can complete their initial paperwork, track the progress of their file and message the team.' }));
						return;
					} else {
						dispatch(UI.setError({ visible: true, message: 'Instruction Failed' }));
						return;
					}
				});
			}
			if (quotes.quote.type === 'Sale') {
				dispatch(Quotes.instructSale(state) as unknown as AnyAction).then((result: any) => {
					let action;
					try {
						action = JSON.parse(result.payload as string);
					} catch (e) {
						dispatch(UI.setError({ visible: true, message: e as string }));
						return;
					}
					if (action.Status === 'OK') {
						dispatch(UI.setInfo({ visible: true, message: 'Thank you for your instruction. The file will be opened within the next 4 working hours. We will send to the client their PLS 247 app log in details shortly. Within our app, they can complete their initial paperwork, track the progress of their file and message the team.' }));
						return;
					} else {
						dispatch(UI.setError({ visible: true, message: 'Instruction Failed' }));
						return;
					}
				});
			}
		}
	}
}

export const saveQuote = () => {
	const dispatch = store.dispatch;
	const quotes = store.getState().quotes;
	const user = store.getState().user;
	const qfid = "QF" + quotes.quote.quoteid;
	const ifid = "IF" + quotes.quote.quoteid;

	if (!quotes.quote.isSaving) {
		dispatch(Quotes.setSaving(true));
		const getquoteform = () => new Promise((resolve) => resolve(dispatch((Forms.getFormValues({ element: 'QF', form: qfid })) as unknown as AnyAction)));
		const getinstructionform = () => new Promise((resolve) => resolve(dispatch((Forms.getFormValues({ element: 'IF', form: ifid })) as unknown as AnyAction)));
		getquoteform().then(() => {
			getinstructionform().then(() => {
				const jsonqf = getJSONWithFormValues(qfid);
				const jsonqb = JSON.stringify(quotes.quote.quotebreakdown);
				const jsonif = getJSONWithFormValues(ifid);
				const state: Quotes.acceptQuoteState = {
					id: quotes.quote.quoteid,
					generated: quotes.quote.generated,
					accepted: quotes.quote.accepted,
					instructed: quotes.quote.instructed,
					schemeid: getFormValueWithId(qfid, 'quote_scheme_id'),
					introducerid: getFormValueWithId(qfid, 'quote_introducer_id'),
					developerid: getFormValueWithId(qfid, 'quote_developer_id'),
					siteid: getFormValueWithId(qfid, 'quote_site_id'),
					mattertype: quotes.quote.type,
					createdby: user.id,
					filename: '',
					quoteformdata: jsonqf,
					quotebreakdowndata: jsonqb,
					instructionformdata: jsonif
				}
				dispatch(Quotes.setQuoteFormData(jsonqf) as unknown as AnyAction);
				dispatch(Quotes.setInstructionFormData(jsonif) as unknown as AnyAction);
				dispatch(Quotes.saveQuote(state) as unknown as AnyAction).then((result: any) => {
					const action = JSON.parse(result.payload as string);
					if(!quotes.quote.quoteid) {
						dispatch(Forms.copyForm({ from: 'QF', to: 'QF' + action.quoteQuote.QuoteID }) as unknown as AnyAction);
						dispatch(Forms.copyForm({ from: 'IF', to: 'IF' + action.quoteQuote.QuoteID }) as unknown as AnyAction);
					}
					dispatch(Quotes.setQuoteId(action.quoteQuote.QuoteID) as unknown as AnyAction);
				});
			});
		})
	}
}

export const acceptQuote = () => {
	const dispatch = store.dispatch;
	const quotes = store.getState().quotes;
	const user = store.getState().user;
	const qfid = "QF" + quotes.quote.quoteid;
	const ifid = "IF" + quotes.quote.quoteid;

	if (!quotes.quote.isAccepting) {
		dispatch(Quotes.setAccepting(true));
		const jsonqf = getJSONWithFormValues(qfid);
		const jsonqb = JSON.stringify(quotes.quote.quotebreakdown);
		const jsonif = getJSONWithFormValues(ifid);
		const state: Quotes.acceptQuoteState = {
			id: quotes.quote.quoteid,
			generated: quotes.quote.generated,
			accepted: quotes.quote.accepted,
			instructed: quotes.quote.instructed,
			schemeid: getFormValueWithId(qfid, 'quote_scheme_id'),
			introducerid: getFormValueWithId(qfid, 'quote_introducer_id'),
			developerid: getFormValueWithId(qfid, 'quote_developer_id'),
			siteid: getFormValueWithId(qfid, 'quote_site_id'),
			mattertype: quotes.quote.type,
			createdby: user.id,
			filename: '',
			quoteformdata: jsonqf,
			quotebreakdowndata: jsonqb,
			instructionformdata: jsonif
		}
		dispatch(Quotes.setQuoteFormData(jsonqf) as unknown as AnyAction);
		dispatch(Quotes.setInstructionFormData(jsonif) as unknown as AnyAction);
		dispatch(Quotes.acceptQuote(state) as unknown as AnyAction).then((result: any) => {
			const action = JSON.parse(result.payload as string);
			dispatch(Forms.copyForm({ from: 'QF', to: 'QF' + action.quoteQuote.QuoteID }) as unknown as AnyAction);
			dispatch(Quotes.setQuoteId(action.quoteQuote.QuoteID) as unknown as AnyAction);
			dispatch(Quotes.setOffset('-200%'));
		});
	}
}

export const emailQuote = () => {
	const dispatch = store.dispatch;
	const quotes = store.getState().quotes;
	const user = store.getState().user;
	const qfid = "QF" + quotes.quote.quoteid;
	const ifid = "IF" + quotes.quote.quoteid;

	if (!quotes.quote.isEmailing) {
		dispatch(Quotes.setEmailing(true));
		const getquoteform = () => new Promise((resolve) => resolve(dispatch((Forms.getFormValues({ element: 'QF', form: qfid })) as unknown as AnyAction)));
		const getinstructionform = () => new Promise((resolve) => resolve(dispatch((Forms.getFormValues({ element: 'IF', form: ifid })) as unknown as AnyAction)));
		getquoteform().then(() => {
			getinstructionform().then(() => {
				const jsonqf = getJSONWithFormValues(qfid);
				const jsonqb = JSON.stringify(quotes.quote.quotebreakdown);
				const jsonif = getJSONWithFormValues(ifid);
				const state: Quotes.acceptQuoteState = {
					id: quotes.quote.quoteid,
					generated: quotes.quote.generated,
					accepted: quotes.quote.accepted,
					instructed: quotes.quote.instructed,
					schemeid: getFormValueWithId(qfid, 'quote_scheme_id'),
					introducerid: getFormValueWithId(qfid, 'quote_introducer_id'),
					developerid: getFormValueWithId(qfid, 'quote_developer_id'),
					siteid: getFormValueWithId(qfid, 'quote_site_id'),
					mattertype: quotes.quote.type,
					createdby: user.id,
					filename: '',
					quoteformdata: jsonqf,
					quotebreakdowndata: jsonqb,
					instructionformdata: jsonif
				}
				dispatch(Quotes.setQuoteFormData(jsonqf) as unknown as AnyAction);
				dispatch(Quotes.setInstructionFormData(jsonif) as unknown as AnyAction);
				dispatch(Quotes.emailQuote(state) as unknown as AnyAction).then((result: any) => {
					const action = JSON.parse(result.payload as string);
					if (action.Status === 'OK') {
						dispatch(UI.setEmailSent(true));
					};
				});
			});
		})
	}
}

export const doFormOnChange = (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement> | React.ChangeEvent<HTMLTextAreaElement>) => {
	const dispatch = store.dispatch;
	let formId: string = (e.target.dataset.formId ? e.target.dataset.formId : '');

	const value = (e.target instanceof HTMLInputElement && e.target.type === 'checkbox' ? e.target.checked.toString() : e.target.value);
	dispatch(Forms.setFormValueWithId({ form: formId, type: e.target.type, id: e.target.name, val: value }));
	if (e.target.name === 'quote_has_a_buyer') {
		dispatch(Forms.setFormValueWithId({ form: formId, type: e.target.type, id: 'quote_sale_ready', val: value === '0' ? '1' : '0' }));
	}
}

export const validateForm = (el: string, id: string): boolean => {
	const dispatch = store.dispatch;

	let valid = true;
	let top = 0;
	const form = document.getElementById(el);
	let ot = 0;
	const elscroll = document.getElementById(el + 'Scroll');
	if (elscroll) {
		ot = elscroll.offsetTop;
	}
	if (form != null) {
		const inputs: NodeListOf<HTMLInputElement> = form.querySelectorAll('input[type="text"], input[type="number"], input[type="date"], select, textarea');
		for (let i = 0; i < inputs.length; i++) {
			let element: HTMLInputElement = inputs[i];
			let validType: string | undefined = element.dataset.validType;
			let validUnique: string | undefined = element.dataset.validUnique;
			let validMessage: string = (typeof element.dataset.validMessage !== 'undefined' ? element.dataset.validMessage : '');
			let uniqueMessage: string = (typeof element.dataset.uniqueMessage !== 'undefined' ? element.dataset.uniqueMessage : '');
			let dateCompare: string = (typeof element.dataset.dateCompare !== 'undefined' ? element.dataset.dateCompare : '');
			let unique: string[] = [];
			if (typeof validUnique !== 'undefined') {
				const uniqueArray: string[] = JSON.parse(validUnique);
				for (let j = 0; j < uniqueArray.length; j++) {
					unique.push(getFormValueWithId(id, uniqueArray[j]));
				}
			}
			const v = validateFromType(validType, element.value, unique, validMessage, uniqueMessage, dateCompare);
			dispatch(Forms.setFormValidWithId({ form: id, type: element.type, id: element.name, val: v.valid }))
			dispatch(Forms.setFormMessageWithId({ form: id, type: element.type, id: element.name, val: v.message }));
			if (!v.valid) {
				valid = false;
				if (top === 0 || element.offsetTop < top) {
					top = element.offsetTop - (ot + 3);
				}
			}
		}
		const radios: NodeListOf<HTMLInputElement> = form.querySelectorAll('input[type="radio"], input[type="checkbox"]');
		for (let i = 0; i < radios.length; i++) {
			let element: HTMLInputElement = radios[i];
			if ((element.name !== 'c1_ind_addr_pop' && element.name !== 'c2_ind_addr_pop' && element.name !== 'c3_ind_addr_pop' && element.name !== 'c4_ind_addr_pop' && element.name !== 'nhg_client_consent') && !form.querySelector(`input[name="${element.name}"]:checked`)) {
				dispatch(Forms.setFormValidWithId({ form: id, type: element.type, id: element.name, val: false }))
				valid = false;
				if (top === 0 || element.offsetTop < top) {
					top = element.offsetTop - (ot + 11);
				}
			} else {
				dispatch(Forms.setFormValidWithId({ form: id, type: element.type, id: element.name, val: true }))
			}
		}
	}
	if (!valid) {
		if (elscroll != null) {
			elscroll.scrollTo({
				top: top,
				left: 0,
				behavior: 'smooth'
			});
		}
	}
	return valid;
}

export const getFormValueWithId = (form: string, id: string): string => {
	const forms = store.getState().forms;
	if (!forms.forms[form]) {
		return '';
	}
	if (!forms.forms[form].data.hasOwnProperty(id)) {
		return '';
	}
	return forms.forms[form].data[id].val;
}

export const getFormValidWithId = (form: string, id: string): boolean => {
	const forms = store.getState().forms;
	if (!forms.forms[form]) {
		return true;
	}
	if (!forms.forms[form].data.hasOwnProperty(id)) {
		return true;
	}
	return forms.forms[form].data[id].valid;
}

export const getFormMessageWithId = (form: string, id: string): string => {
	const forms = store.getState().forms;
	if (!forms.forms[form]) {
		return '';
	}
	if (!forms.forms[form].data.hasOwnProperty(id)) {
		return '';
	}
	return forms.forms[form].data[id].message;
}

export const getJSONWithFormValues = (id: string): string => {
	const forms = store.getState().forms;
	let obj: { [key: string]: { type: string, val: string } } = {};
	for (const p in forms.forms[id].data) {
		obj[p] = { type: forms.forms[id].data[p].type, val: forms.forms[id].data[p].val };
	}
	return JSON.stringify(obj);
}

export const getAddressListWithId = (id: string): Forms.postcodeAddressState[] => {
	const forms = store.getState().forms;
	if (!forms.addresses[id]) {
		return [];
	}
	return forms.addresses[id];
}

export const getPostcodeAddresses = (form: string, id: string) => {
	const dispatch = store.dispatch;

	dispatch(Forms.setGettingAddresses({ id: id, getting: true }));
	const el = id + '_postcode';
	const postcode = getFormValueWithId(form, el);
	dispatch(Forms.getPostcodeAddresses({ id: id, postcode: postcode }) as unknown as AnyAction);
}

export const selectAddress = (e: React.ChangeEvent<HTMLSelectElement>) => {
	const dispatch = store.dispatch;
	const forms = store.getState().forms;
	let formId: string = (e.target.dataset.formId ? e.target.dataset.formId : '');

	const target = e.target.name + (e.target.name.includes('company') ? '_property' : '_house');
	const a: Forms.postcodeAddressState = forms.addresses[e.target.name][parseInt(e.target.value)];
	dispatch(Forms.setFormValueWithId({ form: formId, type: 'text', id: target, val: a.premise }));
	dispatch(Forms.setFormValueWithId({ form: formId, type: 'text', id: e.target.name + '_street', val: a.street }));
	dispatch(Forms.setFormValueWithId({ form: formId, type: 'text', id: e.target.name + '_town', val: a.posttown }));
	dispatch(Forms.setFormValueWithId({ form: formId, type: 'text', id: e.target.name + '_county', val: a.county }));
	dispatch(Forms.setFormValueWithId({ form: formId, type: 'text', id: e.target.name + '_postcode', val: a.postcode }));
	dispatch(Forms.removePostcodeAddresses(e.target.name));
}

const getDeveloperForSite = (siteid: string): string | null => {
	const sites = store.getState().user.sites;
	for (let i = 0; i < sites.length; i++) {
		let site = sites[i];
		if (site.siteid === siteid) {
			return site.developerid;
		}
	}
	return null;
}

export const filterSchemesByDeveloper = (id: string): User.schemesState[] => {
	const schemes = store.getState().user.schemes;
	let fArray: User.schemesState[] = [];
	schemes.forEach((element) => {
		fArray.push(element);
	});
	return fArray;
}

export const filterSitesByDeveloper = (id: string): User.sitesState[] => {
	const sites = store.getState().user.sites;
	let fArray: User.sitesState[] = [];
	fArray.push({ developerid: '', siteid: '169725', site: 'Other' });
	const developer = getFormValueWithId(id, "quote_developer_id");
	sites.forEach((element) => {
		const developerid = getDeveloperForSite(element.siteid);
		if (developer === '' || developer === developerid || developerid === null) {
			fArray.push(element);
		}
	});
	return fArray;
}

export const filterDevelopersBySiteOrScheme = (id: string): User.developerState[] => {
	const developers = store.getState().user.developers;
	let fArray: User.developerState[] = [];
	const site = getFormValueWithId(id, "quote_site_id");
	developers.forEach((element) => {
		const developerid = getDeveloperForSite(site);
		if ((site === '' || element.developerid === developerid)) {
			fArray.push(element);
		}
	});
	return fArray;
}

const validateNotEmpty = (value: string, vm: string): validRetType => {
	if (value === '') {
		return { valid: false, message: vm };
	}
	return { valid: true, message: '' };
}

const validateEmail = (value: string, vm: string): validRetType => {
	const emailRegEx = new RegExp("[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}");
	return { valid: emailRegEx.test(value), message: (value === '' ? '' : vm) };
}

const validateDate = (value: string, vm: string, cp: string): validRetType => {
	const num = cp.match(/\d/g);
	const n = parseInt((num ? num.join("") : "0"));
	let d = new Date(Date.now()).setHours(0, 0, 0, 0);
	const date = new Date(value);
	if (date.toString() === 'Invalid Date') {
		return { valid: false, message: '' };
	}
	if (cp.startsWith('<=')) {
		if (cp.charAt(2) === '-') {
			d = d - n;
		} else {
			d = d + n;
		}
		if (date.getTime() > d) {
			return { valid: false, message: vm };
		}
	}
	if (cp.startsWith('>=')) {
		if (cp.charAt(2) === '-') {
			d = d - n;
		} else {
			d = d + n;
		}
		if (date.getTime() < d) {
			return { valid: false, message: vm };
		}
	}
	if (cp.startsWith('<')) {
		if (cp.charAt(1) === '-') {
			d = d - n;
		} else {
			d = d + n;
		}
		if (date.getTime() >= d) {
			return { valid: false, message: vm };
		}
	}
	if (cp.startsWith('>')) {
		if (cp.charAt(1) === '-') {
			d = d - n;
		} else {
			d = d + n;
		}
		if (date.getTime() <= d) {
			return { valid: false, message: vm };
		}
	}
	return { valid: true, message: '' }
}

export const validateFromType = (type: string | undefined, value: string, unique: string[], vm: string, um: string, cp: string): validRetType => {
	let valid: validRetType = { valid: true, message: '' };
	switch (type) {
		case "*":
			valid = validateNotEmpty(value, vm);
			break;
		case "email":
			valid = validateEmail(value, vm);
			break;
		case "date":
			valid = validateDate(value, vm, cp);
			break;
	}
	if (!valid.valid) {
		return valid;
	}
	if (unique.length > 0) {
		for (let i = 0; i < unique.length; i++) {
			if (value === unique[i]) {
				valid = { valid: false, message: um };
			}
		}
	}
	return valid;
}

export const getUkDate = (date: string): string => {
	if (date === '1900-01-01 00:00:00.000' || !date) { return ''; }
	var dateToChange = new Date(date);
	return dateToChange.toLocaleString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit' });
}
export const getCurrentFormattedDate = () => {
	const now = new Date();

	const year = now.getFullYear();
	const month = String(now.getMonth() + 1).padStart(2, '0');
	const day = String(now.getDate()).padStart(2, '0');

	const hours = String(now.getHours()).padStart(2, '0');
	const minutes = String(now.getMinutes()).padStart(2, '0');
	const seconds = String(now.getSeconds()).padStart(2, '0');
	const milliseconds = String(now.getMilliseconds()).padStart(3, '0');

	return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
}
export const htmlEscape = (str: string): string => {
	return str.toString()
		.replace(/&/g, '&amp')
		.replace(/'/g, '&apos')
		.replace(/"/g, '&quot')
		.replace(/>/g, '&gt')
		.replace(/</g, '&lt');
}